import request from '@/middleware/request'

const getChannel = () => {
  return request({
    url: '/credential',
    method: 'get'
  })
}

const createChannel = data => {
  return request({
    url: '/credential',
    method: 'post',
    data
  })
}

const updateChannel = (id, data) => {
  return request({
    url: `/credential/${id}`,
    method: 'patch',
    data
  })
}

const deleteChannel = id => {
  return request({
    url: `/credential/${id}`,
    method: 'delete'
  })
}

export default {
  getChannel,
  createChannel,
  updateChannel,
  deleteChannel
}
